/* Our Story timeline: fills the rail as you scroll and rolls the sticky year
   gauge to whichever event has crossed the marker line. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Bottom edge of the theme's fixed bars (sticky announcement bar, stuck header),
  // so the gauge sits below them
  function stickyOffset() {
    let offset = 0;
    document.querySelectorAll('.announcement-bar, .site-header').forEach((el) => {
      const pos = getComputedStyle(el).position;
      if (pos !== 'fixed' && pos !== 'sticky') return;
      const r = el.getBoundingClientRect();
      if (r.top <= offset + 1 && r.bottom > offset) offset = r.bottom;
    });
    return Math.round(offset);
  }

  function init(section) {
    if (section.dataset.hmaReady) return;
    section.dataset.hmaReady = 'true';

    const rail = section.querySelector('[data-hma-rail]');
    const fill = section.querySelector('[data-hma-fill]');
    const tip = section.querySelector('[data-hma-tip]');
    const yearBox = section.querySelector('[data-hma-year]');
    const titleEl = section.querySelector('[data-hma-title]');
    const eraEl = section.querySelector('[data-hma-era]');
    const eraLinks = [...section.querySelectorAll('[data-hma-era-link]')];
    const events = [...section.querySelectorAll('.hm-about-ev')];
    if (!rail || !events.length) return;

    section.classList.add('is-ready');
    let current = null;

    function setYear(next, direction) {
      const old = yearBox.querySelector('span:last-child');
      if (old && old.textContent === next) return;
      const span = document.createElement('span');
      span.textContent = next;
      if (reduced || !old || !direction) {
        yearBox.replaceChildren(span);
        return;
      }
      span.className = direction > 0 ? 'is-in-down' : 'is-in-up';
      yearBox.appendChild(span);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          old.className = direction > 0 ? 'is-out-up' : 'is-out-down';
          span.className = '';
          setTimeout(() => old.remove(), 550);
        });
      });
    }

    function update() {
      section.style.setProperty('--hma-sticky-offset', stickyOffset() + 'px');

      // The rail fills down to a line 45% of the way down the viewport
      const marker = window.innerHeight * 0.45;
      const r = rail.getBoundingClientRect();
      const filled = Math.min(Math.max(marker - r.top, 0), r.height);
      fill.style.height = filled + 'px';
      tip.style.top = filled + 'px';

      let active = 0;
      events.forEach((ev, i) => {
        const top = ev.getBoundingClientRect().top + 10;
        const passed = top < marker;
        ev.classList.toggle('is-passed', passed);
        if (top < window.innerHeight * 0.85) ev.classList.add('is-seen');
        if (passed) active = i;
      });

      if (active !== current) {
        const ev = events[active];
        setYear(ev.dataset.year, current === null ? 0 : active - current);
        titleEl.textContent = ev.dataset.title;
        eraEl.textContent = ev.dataset.eraName;
        eraLinks.forEach((a) => a.classList.toggle('is-active', a.dataset.hmaEraLink === ev.dataset.era));
        current = active;
      }
    }

    let ticking = false;
    let settle;
    const onScroll = () => {
      // The theme sticks its header after a scroll, so measure again once things settle
      clearTimeout(settle);
      settle = setTimeout(update, 300);
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  const boot = () => document.querySelectorAll('[data-hma-timeline]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-initialise when the section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', boot);
})();
